import React from 'react';
import { useAsyncDebounce } from 'react-table'
import PropTypes from 'prop-types';

export const Filter = ({ column }) => {
    return (
        <div className=''>
            {column.canFilter && column.render('Filter')}
        </div>
    );
};

export const DefaultColumnFilter = ({
    column: {
        filterValue,
        setFilter,
        preFilteredRows: { length },
    },
}) => {
    return (

        <input
            className="capitalize text-gray-600 dark:text-gray-400 focus:outline-none focus:border 
            focus:border-blue-700 dark:focus:border-blue-700 dark:border-gray-700 dark:bg-gray-800
             bg-white font-normal w-auto h-8 flex items-center pl-3 text-sm border-gray-200 rounded border"
            type="text"
            value={filterValue || ''}
            onChange={(e) => {
                setFilter(e.target.value || undefined);
            }}

            placeholder={`Search (${length}) ...`}
            id="imgurl"

        />


    );
};

export const SelectColumnFilter = ({ column: { filterValue, setFilter, preFilteredRows, id }, }) => {

    const options = React.useMemo(() => {
        const options = new Set();
        preFilteredRows.forEach((row) => {
            options.add(row.values[id]);
        });
        return [...options.values()];

    }, [id, preFilteredRows]);

    return (
        <div className=" text-sm text-gray-800">
            <select
                id='custom-select'
                className="text-gray-600 dark:text-gray-400 focus:outline-none focus:border 
                focus:border-blue-700 dark:focus:border-blue-700 dark:border-gray-700 dark:bg-gray-800
                 bg-white font-normal w-auto flex items-center h-8 text-xs border-gray-300 rounded border "
                value={filterValue}
                onChange={(e) => {
                    setFilter(e.target.value || undefined);
                }}

            >   
                <option value="">All</option>
                {options.map((option) => (
                    !!option &&
                    <option key={option} value={option}>
                        {option?.toString()}
                    </option>
                ))}
            </select>
        </div>

    );
};

export const GlobalFilter = ({
    preGlobalFilteredRows,
    globalFilter,
    setGlobalFilter,
}) => {
    // const count = preGlobalFilteredRows.length
    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(value => {
        setGlobalFilter(value || undefined)
    }, 200)

    return (
        <div className="pt-2 relative mx-auto text-gray-500 ">
            <i className="uil uil-search "></i>
            <svg className="w-5 h-5 absolute left-0 top-0 ml-3 mt-4 text-lg font-bold" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" /></svg>
            <input className="capitalize border border-gray-200 bg-gray-50 h-10 pl-10 rounded text-sm focus:outline-none "
                type="search" name="search"
                value={value || ""}
                onChange={e => {
                    setValue(e.target.value);
                    onChange(e.target.value);
                }}
                // placeholder={`${count} records...`}
                placeholder={`Search ..`}

            />

            {/* <div type="" className=" right-0 top-0 mt-5 mr-4 bg-gray-100" >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                </div> */}
        </div>



    )
}

Filter.propTypes = {
  column: PropTypes.object.isRequired,
};

DefaultColumnFilter.propTypes = {
  column: PropTypes.object.isRequired,
};

SelectColumnFilter.propTypes = {
  column: PropTypes.object.isRequired,
};

GlobalFilter.propTypes = {
  preGlobalFilteredRows: PropTypes.array.isRequired,
  globalFilter: PropTypes.string,
  setGlobalFilter: PropTypes.func.isRequired,
};
